import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { AppShowcase } from './components/AppShowcase';
import { HowItWorks } from './components/HowItWorks';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white selection:bg-[#FFD700] selection:text-black" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Features data-id="element-4" />
        <AppShowcase data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <CallToAction data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}